import { FeatureKeys } from "@/config/feature-keys";
import { lazy } from "react";

// Lazy-loaded pages
const Login = lazy(() => import("@/pages/Auth/Login"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const PhoneCalls = lazy(() => import("@/pages/PhoneCalls/PhoneCalls"));
const CallsEvaluation = lazy(() =>
  import("@/pages/CallsEvaluation/CallsEvaluation")
);
const CallEvaluationReport = lazy(() =>
  import("@/pages/CallEvaluationReport/CallEvaluationReport")
);
const PlayStore = lazy(() => import("@/pages/MobileApps/PlayStore"));
const AppStore = lazy(() => import("@/pages/MobileApps/AppStore"));
const UsersPage = lazy(() => import("@/pages/Settings/Users"));
const RolesPage = lazy(() => import("@/pages/Settings/Roles"));
const LLMProvider = lazy(() => import("@/pages/LLMProvider/LLMProvider"));
const TranscriptionProvider = lazy(() =>
  import("@/pages/TranscriptionProvider/TranscriptionProvider")
);
const CallEvaluationDetailsSettings = lazy(() =>
  import("@/pages/Settings/CallEvaluationDetails")
);
const AppLinks = lazy(() => import("@/pages/AppLinks/AppLinks"));
const UsageDetails = lazy(() => import("@/pages/Settings/UsageDetails"));
const VoiceCallApi = lazy(() => import("@/pages/ApiDocs/VoiceCallApi"));
const CallEvaluationApi = lazy(() => import("@/pages/ApiDocs/CallEvaluationApi"));

const APP_PREFIX_PATH = "/app";

// Public routes (flat)
export const PUBLIC_ROUTES = [
  {
    key: "login",
    path: "/auth/login",
    Component: Login,
  },
];

// Protected routes (flat)
export const PROTECTED_ROUTES = [
  {
    key: "dashboard",
    path: `${APP_PREFIX_PATH}/dashboard`,
    Component: Dashboard,
    featureKey: FeatureKeys.DASHBOARD,
  },
  {
    key: "voicecalls.feedback",
    path: `${APP_PREFIX_PATH}/call-reviews`,
    Component: PhoneCalls,
    featureKey: FeatureKeys.VOICECALLS,
  },
  {
    key: "voicecalls.analysis",
    path: `${APP_PREFIX_PATH}/calls-evaluation`,
    Component: CallsEvaluation,
    featureKey: FeatureKeys.CALLSEVALUATION,
  },
  {
    key: "voicecalls.report",
    path: `${APP_PREFIX_PATH}/calls-evaluation/:callId`,
    Component: CallEvaluationReport,
    featureKey: FeatureKeys.CALLSEVALUATIONDETAILS,
  },
  {
    key: "mobile.playstore",
    path: `${APP_PREFIX_PATH}/play-store-reviews`,
    Component: PlayStore,
    featureKey: FeatureKeys.PLAYSTORE,
  },
  {
    key: "mobile.appstore",
    path: `${APP_PREFIX_PATH}/app-store-reviews`,
    Component: AppStore,
    featureKey: FeatureKeys.APPSTORE,
  },
  {
    key: "settings.configuration",
    path: `${APP_PREFIX_PATH}/configuration`,
    Component: LLMProvider,
    featureKey: FeatureKeys.CONFIGURATION,
  },
  {
    key: "settings.transcription",
    path: `${APP_PREFIX_PATH}/transcription`,
    Component: TranscriptionProvider,
    featureKey: FeatureKeys.TRANSCRIPTION,
  },
  {
    key: "settings.app_links",
    path: `${APP_PREFIX_PATH}/app-store-links`,
    Component: AppLinks,
    featureKey: FeatureKeys.APP_LINK,
  },
  {
    key: "settings.users",
    path: `${APP_PREFIX_PATH}/settings/users`,
    Component: UsersPage,
    featureKey: FeatureKeys.USERS,
  },
  {
    key: "settings.roles",
    path: `${APP_PREFIX_PATH}/settings/roles`,
    Component: RolesPage,
    featureKey: FeatureKeys.ROLES,
  },
  {
    key: "settings.call_evaluation_details",
    path: `${APP_PREFIX_PATH}/settings/call-evaluation-details`,
    Component: CallEvaluationDetailsSettings,
    featureKey: FeatureKeys.CALLSEVALUATIONDETAILS,
  },
  {
    key: "settings.usage",
    path: `${APP_PREFIX_PATH}/settings/usage-details`,
    Component: UsageDetails,
    featureKey: FeatureKeys.USAGE,
  },
  {
    key: "apidocs.voice_call",
    path: `${APP_PREFIX_PATH}/api-docs/voice-call`,
    Component: VoiceCallApi,
    featureKey: FeatureKeys.API_DOCS,
  },
  {
    key: "apidocs.call_evaluation",
    path: `${APP_PREFIX_PATH}/api-docs/call-evaluation`,
    Component: CallEvaluationApi,
    featureKey: FeatureKeys.API_DOCS,
  },
];
